// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".describe img[data-v-f34f42e4] {\n  width: 30px;\n  height: 25px;\n}\n#successbox .infotip[data-v-f34f42e4] {\n  text-indent: 30px;\n  line-height: 2;\n}\n", ""]);
// Exports
module.exports = exports;
